import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../config/api';

const Cart = () => {
  const [cart, setCart] = useState([]);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [lastOrderId, setLastOrderId] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');
  const [formData, setFormData] = useState({ payment_method: 'Mobile Money', delivery_address: '' });

  useEffect(() => {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
  }, []);

  const removeFromCart = (index) => {
    const newCart = cart.filter((_, i) => i !== index);
    setCart(newCart);
    localStorage.setItem('cart', JSON.stringify(newCart));
    window.dispatchEvent(new Event('cartUpdated'));
  };

  const getTotal = () => {
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    if (cart.length === 0) {
      setErrorMsg('Your cart is empty!');
      return;
    }

    try {
      const response = await api.post('/orders.php', {
        payment_method: formData.payment_method,
        delivery_address: formData.delivery_address,
        items: cart.map(item => ({
          menu_id: item.menu_id,
          quantity: item.quantity,
          }))
      });

      if (response.data.success) {
        setOrderSuccess(true);
        setLastOrderId(response.data.order_id || null);
        setCart([]);
        localStorage.removeItem('cart');
        window.dispatchEvent(new Event('cartUpdated'));
      } else {
        setErrorMsg(response.data.message || 'Order failed. Please try again.');
      }
    } catch (error) {
      console.error('Order error:', error);
      setErrorMsg('Order failed. Please try again.');
    }
  };

  return (
    <div>
      {/* Cart Header */}
      <section className="section-padding text-center" style={{ 
        background: 'linear-gradient(rgba(26, 26, 26, 0.8), rgba(26, 26, 26, 0.9)), url("https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=1920&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        color: '#ffffff'
      }}>
        <div className="container">
          <span style={{ color: '#D4AF37', letterSpacing: '3px', textTransform: 'uppercase', fontSize: '0.85rem', fontWeight: 600 }}>
            Your Order
          </span>
          <h1 className="mt-3 mb-4" style={{ fontFamily: 'Playfair Display, serif', fontSize: '3.5rem', fontWeight: 600, color: '#ffffff' }}>
            Shopping Cart
          </h1>
          <p style={{ fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto', color: '#ffffff' }}>
            Review your selections and proceed to checkout
          </p>
        </div>
      </section>

      {/* Cart Content */}
      <section className="section-padding" style={{ backgroundColor: '#faf8f5' }}>
        <div className="container">
          {orderSuccess ? (
            <div className="text-center py-5">
              <div style={{ fontSize: '4rem', color: '#4CAF50', marginBottom: '20px' }}>✓</div>
              <h3 className="mb-4" style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.5rem', color: '#333' }}>
                Order Placed Successfully!
              </h3>
              <p className="text-muted mb-4">Thank you for your order. We'll prepare it right away.</p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                {lastOrderId && (
                  <Link to={`/track-order/${lastOrderId}`} className="btn text-white" style={{
                    backgroundColor: '#1A1A1A', border: 'none', padding: '14px 28px',
                    fontSize: '0.9rem', letterSpacing: '0.5px', textTransform: 'uppercase',
                    fontWeight: 600, borderRadius: '2px', textDecoration: 'none'
                  }}>
                    Track Your Order
                  </Link>
                )}
                <Link to="/menu" className="btn text-white" style={{
                  backgroundColor: '#D4AF37', border: 'none', padding: '14px 28px',
                  fontSize: '0.9rem', letterSpacing: '0.5px', textTransform: 'uppercase',
                  fontWeight: 600, borderRadius: '2px', textDecoration: 'none'
                }}>
                  Order More
                </Link>
              </div>
            </div>
          ) : cart.length === 0 ? (
            <div className="text-center py-5">
              <div style={{ fontSize: '4rem', color: '#D4AF37', marginBottom: '20px' }}>✦</div>
              <h3 className="text-muted mb-4" style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.5rem' }}>
                Your cart is empty
              </h3>
              <Link 
                to="/menu" 
                className="btn text-white"
                style={{ 
                  backgroundColor: '#D4AF37', 
                  border: 'none', 
                  padding: '14px 32px',
                  fontSize: '1rem',
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  fontWeight: 600,
                  borderRadius: '2px',
                  boxShadow: '0 4px 20px rgba(212, 175, 55, 0.3)'
                }}
              >
                Browse Menu
              </Link>
            </div>
          ) : (
            <div className="row">
              <div className="col-lg-8 mb-4 mb-lg-0">
                <div className="card border-0" style={{ backgroundColor: '#ffffff', boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
                  <div className="card-body p-5">
                    <h2 className="mb-4" style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.8rem', fontWeight: 600 }}>
                      Order Items
                    </h2>
                    {cart.map((item, index) => (
                      <div key={index} className="d-flex justify-content-between align-items-start border-bottom py-4" style={{ borderColor: '#f0f0f0' }}>
                        <div className="flex-grow-1">
                          <h5 className="fw-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>{item.item_name}</h5>
                          <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>Quantity: {item.quantity}</p>
                        </div>
                        <div className="d-flex align-items-center gap-4">
                          <h5 className="fw-bold mb-0" style={{ color: '#4CAF50', fontFamily: 'Playfair Display, serif' }}>
                            UGX {Number(item.price * item.quantity).toLocaleString()}
                          </h5>
                          <button 
                            className="btn btn-sm"
                            style={{ 
                              backgroundColor: 'transparent', 
                              border: '1px solid #e0e0e0',
                              color: '#D4AF37',
                              padding: '8px 16px',
                              borderRadius: '2px'
                            }}
                            onClick={() => removeFromCart(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    ))}
                    
                    <div className="mt-5 pt-4" style={{ borderTop: '2px solid #f0f0f0' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <h4 className="fw-bold mb-0" style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.5rem' }}>
                          Total
                        </h4>
                        <h4 className="fw-bold mb-0" style={{ color: '#D4AF37', fontFamily: 'Playfair Display, serif', fontSize: '1.5rem' }}>
                          UGX {Number(getTotal()).toLocaleString()}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="card border-0" style={{ backgroundColor: '#ffffff', boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
                  <div className="card-body p-5">
                    <h2 className="mb-4" style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.8rem', fontWeight: 600 }}>
                      Checkout
                    </h2>
                    
                    <form onSubmit={handleSubmit}>
                      {errorMsg && (
                        <div style={{
                          padding: '12px 16px', borderRadius: '8px', marginBottom: '20px',
                          backgroundColor: '#FFEBEE', color: '#C62828',
                          fontSize: '0.88rem', textAlign: 'center'
                        }}>
                          {errorMsg}
                        </div>
                      )}
                      <div className="mb-4">
                        <label className="form-label" style={{ fontWeight: 500, fontSize: '0.9rem' }}>Payment Method</label>
                        <select
                          className="form-select"
                          name="payment_method"
                          value={formData.payment_method}
                          onChange={(e) => setFormData({...formData, payment_method: e.target.value})}
                          style={{ padding: '12px 16px' }}
                        >
                          <option value="Mobile Money">Mobile Money</option>
                          <option value="Visa">Visa</option>
                          <option value="Cash">Cash on Delivery</option>
                        </select>
                      </div>

                      <div className="mb-5">
                        <label className="form-label" style={{ fontWeight: 500, fontSize: '0.9rem' }}>Delivery Address</label>
                        <textarea 
                          className="form-control" 
                          rows="4"
                          name="delivery_address"
                          value={formData.delivery_address}
                          onChange={(e) => setFormData({...formData, delivery_address: e.target.value})}
                          placeholder="Enter your delivery address"
                          style={{ padding: '12px 16px', resize: 'none' }}
                        ></textarea>
                      </div>

                      <button 
                        type="submit" 
                        className="btn text-white w-100"
                        style={{ 
                          backgroundColor: '#D4AF37', 
                          border: 'none', 
                          padding: '16px 32px',
                          fontSize: '1rem',
                          letterSpacing: '2px',
                          textTransform: 'uppercase',
                          fontWeight: 600,
                          borderRadius: '2px',
                          boxShadow: '0 4px 20px rgba(212, 175, 55, 0.3)'
                        }}
                      >
                        Place Order
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Cart;

